import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getAnalytics } from 'firebase/analytics';

const firebaseConfig = {
  apiKey: "AIzaSyBf3mOJ_SnoTwnDMNUkt0kOFI157RRwr2o",
  authDomain: "magicmoonstudiosnew.firebaseapp.com",
  projectId: "magicmoonstudiosnew",
  storageBucket: "magicmoonstudiosnew.firebasestorage.app",
  messagingSenderId: "493706265432",
  appId: "1:493706265432:web:08ea86b846e14cbfbb5b2d",
  measurementId: "G-49FKWN1HBR",
};

const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);

// Analytics (optional, won't break if blocked)
try { getAnalytics(app); } catch (_) {}

export default app;
